export const SPECS_SCOPE = 'site-search';

export const enum Spec {
  SearchSuggestions = 'searchSuggestions',
  SearchSamples = 'specs.siteSearch.SearchSamples',
  SearchBoxToggle = 'specs.siteSearch.HideSearchBoxToggle',
  FuzzySearch = 'specs.siteSearch.FuzzySearch',
}
